
class Project {
  constructor(data = {}) {
    this.projectId = data.projectId || '';
    this.type = data.type || '';
    this.name = data.name || '';
    this.address = data.address || '';
    this.projectSize = data.projectSize || '';
    this.sizeUnit = data.sizeUnit || '';
    this.buildDepartment = data.buildDepartment || '';
    this.totalDepartment = data.totalDepartment || '';
    this.companyId = data.companyId || '';
    this.dutyScope = data.dutyScope || '';
    this.majorContractType = data.majorContractType || '';
    this.planStartupTime = data.planStartupTime || '';
    this.planCompletedTime = data.planCompletedTime || '';
    this.qualityStandard = data.qualityStandard || '';
    this.remark = data.remark || '';
  }
}

class SplitProject {
  constructor(data = {}) {
    this.assistMaterials = data.assistMaterials || [];
    this.dutyScope = data.dutyScope || '';
    this.majorContractType = data.majorContractType || '';
    this.name = data.name || '';
    this.needUserNumber = data.needUserNumber || '';
    this.parentId = data.parentId || '';
    this.planCompletedTime = data.planCompletedTime || '';
    this.planStartupTime = data.planStartupTime || '';
    this.prePrice = data.prePrice || '';
    this.priceUnit = data.priceUnit || '';
    this.projectRemark = data.projectRemark || '';
    this.projectSize = data.projectSize || '';
    this.qualityStandard = data.qualityStandard || '';
    this.settlement = data.settlement || '';
    this.subpackageMode = data.subpackageMode || '';
    this.subpackageType = data.subpackageType || '';
    this.totalAmout = data.totalAmout || '';
    this.payMethod = data.payMethod || '';
    this.sizeUnit = data.sizeUnit || '';
    this.projectId = data.projectId || '';
    this.dutyCompanyName = data.dutyCompanyName || '';
  }
}

class AssistProject {
  constructor(data = {}) {
    this.address = data.address || '';
    this.assistMaterials = data.assistMaterials || [];
    this.companyId = data.companyId || '';
    this.name = data.name || '';
    this.parentId = data.parentId || '';
    this.planCompletedTime = data.planCompletedTime || '';
    this.planStartupTime = data.planStartupTime || '';
    this.prePrice = data.prePrice || '';
    this.priceUnit = data.priceUnit || '';
    this.projectCharacter = data.projectCharacter || '';
    this.projectId = data.projectId || '';
    this.projectRemark = data.projectRemark || '';
    this.projectSize = data.projectSize || '';
    this.qualityStandard = data.qualityStandard || '';
    this.settlement = data.settlement || '';
    this.sizeUnit = data.sizeUnit || '';
    this.workerBenefits = data.workerBenefits || [];
    this.dutyCompanyName = data.dutyCompanyName || '';
  }
}

class AcceptanceApply {
  constructor(data = {}) {
    this.acceptanceTime = data.acceptanceTime || '';
    this.attachmentIdList = data.attachmentIdList || [];
    this.companyId = data.companyId || '';
    this.count = data.count || '';
    this.finished = data.finished || '0';
    this.projectId = data.projectId || '';
    this.remark = data.remark || '';
    this.title = data.title || '';
  }
}

class Acceptance {
  constructor(data = {}) {
    this.acceptanceItem = data.acceptanceItem || '';
    this.applyId = data.applyId || '';
    this.attachmentIdList = data.attachmentIdList || [];
    this.companyId = data.companyId || '';
    this.progressStar = data.progressStar || '';
    this.projectId = data.projectId || '';
    this.remark = data.remark || '';
    this.result = data.result || '';
    this.star = data.star || 0;
  }
}

class Manager {
  constructor(data = {}) {
    this.companyId = data.companyId || '';
    this.projectId = data.projectId || '';
    this.dpm = (data.roleUserMap || {}).dpm || [];
    this.forecastInspector = (data.roleUserMap || {}).forecastInspector || [];
    this.pm = (data.roleUserMap || {}).pm || [];
    this.professionLeader = (data.roleUserMap || {}).professionLeader || [];
    this.projectAdmin = (data.roleUserMap || {}).projectAdmin || [];
    this.qualityInspector = (data.roleUserMap || {}).qualityInspector || [];
    this.safeInspector = (data.roleUserMap || {}).safeInspector || [];
    this.techLeader = (data.roleUserMap || {}).techLeader || [];
    this.relatPerson = (data.roleUserMap || {}).relatPerson || [];
    this.updateProjectManager = data.updateProjectManager;
  }
}

class RewPun {
  constructor(data = {}) {
    this.id = data.id || '';
    this.type = data.type || '';
    this.projectId = data.projectId || '';
    this.amount = data.amount || '';
    this.attachmentList = data.attachmentList || [];
    this.issuanceTime = data.issuanceTime || '';
    this.remark = data.remark || '';
  }
}

class WorkLog {
  constructor(data = {}) {
    this.attachIds = data.attachIds || [];
    this.companyId = data.companyId || '';
    this.createTime = data.createTime || '';
    this.itemRecord = data.itemRecord || '';
    this.itemRequire = data.itemRequire || '';
    this.jobPlan = data.jobPlan || '';
    this.projectId = data.projectId || '';
    this.temperature = data.temperature || '';
    this.weather = data.weather || '';
    this.windPower = data.windPower || '';
    this.windDirection = data.windDirection || '';
  }
}

export {
  Project, SplitProject, AssistProject, AcceptanceApply, Acceptance, Manager,
  RewPun, WorkLog,
};



// WEBPACK FOOTER //
// ./src/model/reqObject.js